import React, { Component } from "react";
import PropTypes from "prop-types";

import { spring, StaggeredMotion } from "react-motion";

import ShowcaseCollectionCard from "components/ShowcaseCollection/ShowcaseCollectionCard";

import { baseAppId } from "settings";

export default class ShowcaseCollection extends Component {
  constructor(props) {
    super(props);

    this.timer = null;
    this.state = {
      showcaseCollection: [],
    };
  }

  componentDidMount() {
    this.init();
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  init() {
    const { language, stands: showcaseCollection } = this.props;

    const startingValues = Object.keys(showcaseCollection).map(() => ({
      data: 0,
      pos: 20,
    }));

    const items = (
      <StaggeredMotion
        defaultStyles={startingValues}
        styles={(prevInterpolatedStyles) =>
          prevInterpolatedStyles.map((_, i) =>
            i === 0
              ? {
                  data: spring(1, { stiffness: 320, damping: 28 }),
                  pos: spring(0, { stiffness: 320, damping: 28 }),
                }
              : {
                  data: spring(prevInterpolatedStyles[i - 1].data, {
                    stiffness: 320,
                    damping: 28,
                  }),
                  pos: spring(prevInterpolatedStyles[i - 1].pos, {
                    stiffness: 320,
                    damping: 28,
                  }),
                }
          )
        }
      >
        {(styles) => (
          <React.Fragment>
            {showcaseCollection.map((showcase, i) => {
              console.log(showcase);
              const {
                propertyName,
                headerImages,
                type,
                id,
                description,
                icon,
              } = showcase;
              const style = {
                opacity: `${styles[i].data}`,
                transform: `translateY(${styles[i].pos}%)`,
              };

              if (!propertyName) {
                return null;
              }

              return (
                <React.Fragment key={id}>
                  <div
                    key={id}
                    className="ShowcaseCollectionCard__Animated"
                    style={style}
                  >
                    <ShowcaseCollectionCard
                      appId={baseAppId}
                      key={id}
                      index={i}
                      image={icon}
                      subtitle={description}
                      title={propertyName}
                      type={type}
                      itemID={id}
                      language={language}
                    />
                  </div>
                </React.Fragment>
              );
            })}
          </React.Fragment>
        )}
      </StaggeredMotion>
    );

    this.setState({ showcaseCollection: items });
  }

  render() {
    const { showcaseCollection } = this.state;

    return (
      <div className="showcaseCollection__Grid">
        {showcaseCollection}
        <style>
          {
            "\
        .fancybox-slide--iframe .fancybox-content { max-width  : 960px; margin: 0; } "
          }
        </style>
      </div>
    );
  }
}

ShowcaseCollection.propTypes = {
  language: PropTypes.string,
  stands: PropTypes.arrayOf(
    PropTypes.shape({
      address: PropTypes.string,
      category: PropTypes.string,
      city: PropTypes.string,
      contactEmail: PropTypes.string,
      coords: PropTypes.shape({
        latitude: PropTypes.number,
        longitude: PropTypes.number,
      }),
      country: PropTypes.string,
      description: PropTypes.string,
      headerImages: PropTypes.arrayOf(PropTypes.string),
      hide_address: PropTypes.string,
      icon: PropTypes.string,
      id: PropTypes.string,
      image: PropTypes.string,
      live: PropTypes.string,
      offer: PropTypes.string,
      phoneNumber: PropTypes.string,
      propertyName: PropTypes.string,
      region: PropTypes.string,
      // show: PropTypes,
      subCat: PropTypes.string,
      summary: PropTypes.string,
      userInfoID: PropTypes.string,
    })
  ).isRequired,
};

ShowcaseCollection.defaultProps = {
  language: "en",
};
